import script from "./errorxp.vue?vue&type=script&setup=true&lang=js"
export * from "./errorxp.vue?vue&type=script&setup=true&lang=js"

import "./errorxp.vue?vue&type=style&index=0&id=e7df9c40&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e7df9c40"]])

export default __exports__